module.exports = __webpack_public_path__ + "static/img/7.04fdaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7.png
// module id = 6KU3
// module chunks = 4